var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Button, fontTokens, GBChips, GBTypography } from '@leapfinance/geebee-component-library';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Pagination, Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from '@mui/material';
import { format } from 'date-fns';
import { nanoid } from 'nanoid';
import ActionMenu from './ActionMenu';
var getStatusChips = function (status) {
    switch (status) {
        case 'ACTIVE':
            return React.createElement(GBChips, { title: "Active", variant: "success", containerClasses: "lfc-w-fit" });
        case 'DEACTIVATED':
            return (React.createElement(GBChips, { title: "Disabled", variant: "secondary", containerClasses: "lfc-w-fit", endIcon: React.createElement(Tooltip, { title: 'User will be able to login but not create new student/application' },
                    React.createElement("div", { className: "lfc-flex" },
                        React.createElement(InfoOutlinedIcon, { className: "lfc-text-sm" }))) }));
        case 'DELETED':
            return (React.createElement(GBChips, { title: "Deleted", variant: "error", containerClasses: "lfc-w-fit", endIcon: React.createElement(Tooltip, { title: 'User will not be able to login in Unisetu' },
                    React.createElement("div", { className: "lfc-flex" },
                        React.createElement(InfoOutlinedIcon, { className: "lfc-text-sm" }))) }));
        default:
            return React.createElement(React.Fragment, null);
    }
};
function UsersTable(_a) {
    var _b = _a.agentsData, agentsData = _b === void 0 ? [] : _b, paginationProps = _a.paginationProps, onMenuClick = _a.onMenuClick, _c = _a.isLoading, isLoading = _c === void 0 ? false : _c, onViewAllApplicationsClick = _a.onViewAllApplicationsClick, onAddSubAgent = _a.onAddSubAgent, _d = _a.source, source = _d === void 0 ? 'CSP' : _d;
    var getOptionsToHide = function (agentStatus) {
        var optionsToHide = [];
        if (source === 'SPEEDUP') {
            optionsToHide.push('VIEW_STUDENT_FUNNEL');
        }
        if (agentStatus === 'ACTIVE') {
            optionsToHide.push('ACTIVATE');
        }
        else if (agentStatus === 'DEACTIVATED') {
            optionsToHide.push('DISABLE');
        }
        else if (agentStatus === 'DELETED') {
            optionsToHide.push('DELETE');
        }
        return optionsToHide;
    };
    return (React.createElement("div", { className: "lfc-py-4 lfc-px-6 lfc-flex lfc-flex-col lfc-gap-4" },
        React.createElement("div", { className: "lfc-bg-white lfc-p-3 lfc-border lfc-rounded-lg" },
            React.createElement(TableContainer, { sx: {
                    '& th': __assign(__assign({}, fontTokens.body4Semibold), { padding: '8px' }),
                    '& td': __assign(__assign({}, fontTokens.body4), { padding: '8px' })
                } },
                React.createElement(Table, { sx: { borderCollapse: 'separate', borderSpacing: '0 8px' } },
                    React.createElement(TableHead, null,
                        React.createElement(TableRow, { className: "lfc-bg-gbTokens-primary-100 lfc-border-[2px] lfc-border-gbTokens-primary-300 [&>th]:lfc-border-r-2 [&>th]:lfc-border-t-2 [&>th]:lfc-border-b-2 [&>th]:lfc-border-gbTokens-primary-300" },
                            React.createElement(TableCell, { align: "center", className: "lfc-border-l-2" }, "Company Name"),
                            React.createElement(TableCell, { align: "center" }, "Username"),
                            React.createElement(TableCell, { align: "center" }, "Account Status"),
                            React.createElement(TableCell, { align: "center" }, "Created on Date"),
                            React.createElement(TableCell, { align: "center" }, "Action"))),
                    React.createElement(TableBody, null,
                        isLoading &&
                            new Array(10).fill(0).map(function () { return (React.createElement(TableRow, { key: nanoid() },
                                React.createElement(TableCell, { colSpan: 5, className: "lfc-h-[50px] lfc-p-0" },
                                    React.createElement(Skeleton, { variant: "rectangular", className: "lfc-h-full lfc-w-full" })))); }),
                        !isLoading && agentsData.length === 0 ? (React.createElement(TableRow, null,
                            React.createElement(TableCell, { colSpan: 5 },
                                React.createElement("div", { className: " lfc-text-center lfc-flex lfc-flex-col lfc-items-center lfc-justify-center lfc-h-full lfc-gap-6 lfc-p-6" },
                                    React.createElement("div", { className: "lfc-w-[150px] lfc-h-[116px] lfc-relative " },
                                        React.createElement("img", { src: "/assets/icons/course-finder/empty-could.svg" })),
                                    React.createElement("div", { className: "lfc-flex lfc-flex-col lfc-gap-3 lfc-text-center  lfc-items-center" },
                                        React.createElement(GBTypography, { variant: "h1Semibold" }, "No Sub Agents Found!"),
                                        React.createElement(Button, { onClick: function () { return onAddSubAgent === null || onAddSubAgent === void 0 ? void 0 : onAddSubAgent(); }, className: "lfc-w-fit" }, "Add Sub Agent"),
                                        React.createElement("br", null)))))) : (!isLoading &&
                            agentsData.length > 0 &&
                            agentsData.map(function (agent, index) {
                                var _a, _b, _c;
                                var dateTimeWithoutTimeZone = (_b = (_a = agent === null || agent === void 0 ? void 0 : agent.createdAt) === null || _a === void 0 ? void 0 : _a.split('+')) === null || _b === void 0 ? void 0 : _b[0];
                                var date = dateTimeWithoutTimeZone ? format(new Date(dateTimeWithoutTimeZone), 'dd-MM-yyy') : null;
                                return (React.createElement(TableRow, { key: index, className: "[&>td]:lfc-border-b [&>td]:lfc-border-r [&>td]:lfc-max-w-[260px] [&>td]:lfc-break-words" },
                                    React.createElement(TableCell, { align: "center", className: "lfc-border-l" }, agent === null || agent === void 0 ? void 0 : agent.companyName),
                                    React.createElement(TableCell, { align: "center" }, (_c = agent === null || agent === void 0 ? void 0 : agent.subAgentUser) === null || _c === void 0 ? void 0 : _c.userName),
                                    React.createElement(TableCell, { align: "center" },
                                        React.createElement("div", { className: "lfc-flex lfc-justify-center" }, getStatusChips(agent.status))),
                                    React.createElement(TableCell, { align: "center" }, date),
                                    React.createElement(TableCell, { align: "center" },
                                        React.createElement("div", { className: "lfc-flex lfc-justify-center" },
                                            source === 'CSP' ? (React.createElement(Button, { variant: "link", onClick: function () {
                                                    onViewAllApplicationsClick === null || onViewAllApplicationsClick === void 0 ? void 0 : onViewAllApplicationsClick(agent.id);
                                                } }, "View All Applications")) : null,
                                            React.createElement(ActionMenu, { onMenuClick: function (props) {
                                                    onMenuClick === null || onMenuClick === void 0 ? void 0 : onMenuClick(agent, props);
                                                }, hideOptions: getOptionsToHide(agent === null || agent === void 0 ? void 0 : agent.status) })))));
                            })))))),
        React.createElement("div", { className: "lfc-self-center" },
            React.createElement(Pagination, __assign({ sx: {
                    marginY: '1rem',
                    '.Mui-selected': {
                        color: '#424242',
                        backgroundColor: '#E2E2FF !important',
                        border: '1px solid #4432ff',
                        ':hover': {
                            backgroundColor: '#3F51B5 !important',
                            color: '#FFFFFF !important'
                        }
                    },
                    button: __assign(__assign({}, fontTokens.body4), { color: '#424242', backgroundColor: 'white', ':hover': {
                            backgroundColor: '#3F51B5 !important',
                            color: '#FFFFFF !important'
                        } })
                }, 
                // onChange={handlePagination}
                count: 10, page: 1, variant: "outlined", shape: "rounded", siblingCount: 1, boundaryCount: 1, size: "medium", defaultPage: 1 }, paginationProps)))));
}
export default UsersTable;
//# sourceMappingURL=UsersTable.js.map